<template>
  <v-container fluid class="pa-0">
    <v-row justify="center" align="center" style="min-height: 100vh;">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="text-center pa-8">
          <v-icon size="80" color="red" class="mb-6">
            mdi-lock
          </v-icon>

          <h1 class="text-h4 mb-4">
            Joukkue suljettu
          </h1>

          <p class="text-body-1 mb-4">
            Joukkue on suljettu väliaikaisesti. Et voi käyttää palvelua tällä hetkellä. Ota tarvittaessa yhteyttä aku@epesis.com.
          </p>

          <div v-if="isAdmin && currentTeam.closed_reason" class="mb-6">
            <h3 class="text-h6 mb-3">Sulkemisen syy:</h3>
            <v-card outlined class="pa-4 text-left">
              <p class="text-body-1">{{ currentTeam.closed_reason }}</p>
            </v-card>
          </div>

          <!-- Team change option if user has multiple teams -->
          <div v-if="userTeams.length > 1" class="mb-6" style="width: 100%;">
            <!-- <h3 class="text-h6 mb-3">Vaihda joukkuetta:</h3> -->
            <ChangeTeamButton :shortenMobile="false" />
          </div>

          <div class="d-flex justify-center">
            <v-btn
              color="primary"
              @click="refreshTeam"
              :loading="refreshing"
              class="mr-4"
              large
            >
              <v-icon class="mr-2">mdi-refresh</v-icon>
              Päivitä
            </v-btn>

            <v-btn
              outlined
              @click="handleLogout"
              large
            >
              <v-icon class="mr-2">mdi-logout</v-icon>
              Kirjaudu ulos
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ChangeTeamButton from '@/components/team/ChangeTeamButton.vue'

export default {
  name: 'TeamClosed',
  components: {
    ChangeTeamButton
  },
  data: () => ({
    refreshing: false
  }),
  computed: {
    ...mapGetters('user', [
      'currentTeam',
      'isAdmin',
      'userTeams',
      'isCurrentTeamClosed'
    ])
  },
  methods: {
    ...mapActions('user', [
      'logout',
      'initUser'
    ]),
    ...mapActions('auth', [
      'refetchToken'
    ]),
    ...mapActions('noti', [
      'info',
      'error'
    ]),
    async handleLogout() {
      await this.logout()
      this.$nextTick(() => {
        this.$router.push('/login')
      })
    },
    async refreshTeam() {
      this.refreshing = true
      try {
        const response = await this.refetchToken(this.currentTeam.id)
        this.initUser(response.data.token)
        this.$nextTick(() => {
          this.info('Joukkueen tiedot päivitetty!')
          this.$router.push('/')
        })
      } catch (error) {
        this.error('Päivitys epäonnistui')
      } finally {
        this.refreshing = false
      }
    }
  }
}
</script>